import React, { useState } from 'react';

import { LinkContainer, LinkTextContainer, LegalContainer } from './Legal.styled';
import { ConsentModal } from 'components/ConsentModal/ConsentModal';
import { Text } from 'components/v2/Typography/Text';

export const Privacy = () => {
  const [openedTermOfUseModal, setOpenedTermOfUseModal] = useState<boolean>(false);
  const [openedPrivacyPolicy, setOpenedPrivacyPolicy] = useState<boolean>(false);

  return (
    <>
      <LegalContainer>
        <LinkContainer>
          <LinkTextContainer onClick={() => setOpenedPrivacyPolicy(true)}>
            <Text size={'xs'}>Privacy Policy</Text>
          </LinkTextContainer>
          <span>·</span>
          <LinkTextContainer onClick={() => setOpenedTermOfUseModal(true)}>
            <Text size={'xs'}>Terms of Use</Text>
          </LinkTextContainer>
        </LinkContainer>
      </LegalContainer>

      <ConsentModal
        id="114"
        open={openedTermOfUseModal}
        title="Term of Use"
        close={() => setOpenedTermOfUseModal(false)}
      />
      <ConsentModal
        id="116"
        open={openedPrivacyPolicy}
        title="Privacy Policy"
        close={() => setOpenedPrivacyPolicy(false)}
      />
    </>
  );
};
